/**
 * Location Sagas
 */
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { isSuccess } from 'Helpers/ResponseStatus';

import {
  GET_LOCATION,
  GET_ALL_LOCATIONS,
  EDIT_LOCATION,
  ADD_LOCATION,
  REMOVE_LOCATION,
  TOGGLE_HIDDEN_LOCATION,
} from 'Actions/types';

import {
    showErrorResponse,
    getLocationSuccess,
    getLocationFailure,
    getAllLocationsSuccess,
    getAllLocationsFailure,
    addLocationSuccess,
    addLocationFailure,
    editLocationSuccess,
    editLocationFailure,
    toggleHiddenLocationSuccess,
    toggleHiddenLocationFailure,
    removeFailure,
    getLocation,
    getAllLocations,
    removeSuccess
} from 'Actions';

import {
  getLocationsRequest,
  getAllLocationsRequest,
  editLocationRequest,
  createLocationRequest,
  removeLocationRequest,
  toggleHiddenLocationRequest,
} from 'Services/employers/EmployerLocationService';


/**
 * Get Location From Server
 */
function* handleGetLocation() {
  try {
    const response = yield call(getLocationsRequest);
    if (isSuccess(response)) {
      yield put(getLocationSuccess(response));
    } else {
      yield put(getLocationFailure(response));
    }
  } catch (error) {
    yield put(showErrorResponse(error));
  }
}

/**
 * Get All Locations From Server
 */
function* handleGetAllLocations() {
  try {
    const response = yield call(getAllLocationsRequest);
    if (isSuccess(response)) {
      yield put(getAllLocationsSuccess(response));
    } else {
      yield put(getAllLocationsFailure(response));
    }
  } catch (error) {
    yield put(showErrorResponse(error));
  }
}


/**
 * Update Location from server
 */
function* handleUpdateLocation(action) {
  try {
    const newlocation = action.payload.newLocation;
    const response = yield call(editLocationRequest, newlocation);

    if (isSuccess(response)) {
        yield put(getAllLocations());
        yield put(editLocationSuccess());
    } else {
      yield put(getLocationFailure(response));
    }
  } catch (error) {
    yield put(getLocationFailure(error));
  }
}

/**
 * Toggle Hidden Location from server
 */
function* handleToggleHiddenLocation(action) {
  try {
    const { locationId, hidden } = action.payload;
    const response = yield call(toggleHiddenLocationRequest, locationId, hidden);

    if (isSuccess(response)) {
        yield put(getAllLocations());
        yield put(toggleHiddenLocationSuccess());
    } else {
      yield put(toggleHiddenLocationFailure(response));
    }
  } catch (error) {
    yield put(toggleHiddenLocationFailure(error));
  }
}

/**
 * Create Location from server
 */
function* handleCreateLocation(action) {
  try {
    const newlocation = action.payload.newLocation;
    const response = yield call(createLocationRequest, newlocation);

    if (isSuccess(response)) {
        yield put(getAllLocations());
        yield put(addLocationSuccess())
    } else {
      yield put(getLocationFailure(response));
    }
  } catch (error) {
      yield put(getLocationFailure(error));
  }
}

/**
 * Remove Location from server
 */
function* handleRemoveLocation(action) {
    try {
        const id = action.payload.id;
        const response = yield call(removeLocationRequest, id);

        if (isSuccess(response)) {
            yield put(getAllLocations());
            yield put(removeSuccess());
        } else {
            yield put(removeFailure(response));
        }
    } catch (error) {
        yield put(removeFailure(error));
    }
}

/**
 * Get Location
 */
export function* watchGetLocations() {
  yield takeEvery(GET_LOCATION, handleGetLocation);
}

/**
 * Create Location
 */
export function* watchCreateLocation() {
  yield takeEvery(ADD_LOCATION, handleCreateLocation);
}

/**
 * Remove Location Saga
 */
export function* watchRemoveLocation() {
  yield takeLatest(REMOVE_LOCATION, handleRemoveLocation);
}

/**
 * Update Location
 */
export function* watchUpdateLocation() {
  yield takeEvery(EDIT_LOCATION, handleUpdateLocation);
}

/**
 * Toggle Hidden Location
 */
export function* watchToggleHiddenLocation() {
  yield takeEvery(TOGGLE_HIDDEN_LOCATION, handleToggleHiddenLocation);
}

/**
 * Get All Locations
 */
export function* watchGetAllLocations() {
  yield takeEvery(GET_ALL_LOCATIONS, handleGetAllLocations);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetLocations),
    fork(watchCreateLocation),
    fork(watchUpdateLocation),
    fork(watchToggleHiddenLocation),
    fork(watchRemoveLocation),
    fork(watchGetAllLocations),
  ]);
}
